// src/components/DisputeModal.js — extracted from App.js
import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import { upsertOne } from "../lib/supabase";

// ─── Dispute Modal ────────────────────────────────────────────────────────────
export function DisputeModal({ request, requests, saveRequests, session, onClose }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!reason.trim()) return;
    setSaving(true);
    const dispute = { raisedBy: session.user.id, reason: reason.trim(), raisedAt: new Date().toISOString(), evidence: [] };
    saveRequests(requests.map(r => r.id !== request.id ? r : {
      ...r,
      status: "Disputed",
      dispute,
      updates: [...(r.updates||[]), {date: new Date().toISOString(), note: `Dispute raised by buyer: ${reason.trim()}`}]
    }));
    setSaving(false);
    onClose();
  };

  return (
    <div className="overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div className="modal fade-in" style={{maxWidth:420,padding:32}}>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,marginBottom:4}}>Raise a Dispute</div>
        <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,color:"var(--ink3)",marginBottom:6}}>{request.id} · {request.watch}</div>
        <div style={{fontSize:13,color:"var(--ink2)",marginBottom:20,lineHeight:1.6}}>Describe the issue clearly. Our team will review the boxing and unboxing videos and contact both parties within 48 hours.</div>
        <label className="fl">What went wrong? *</label>
        <textarea value={reason} onChange={e=>setReason(e.target.value)} placeholder="Watch not as described, item damaged, wrong item received…" rows={4} style={{marginBottom:20}} autoCapitalize="sentences" required/>
        <div style={{display:"flex",gap:10}}>
          <button className="btn-ink" onClick={submit} disabled={!reason.trim()||saving} style={{flex:1,background:"var(--red)",borderColor:"var(--red)",opacity:!reason.trim()?0.5:1}}>{saving?"Submitting…":"Submit Dispute"}</button>
          <button className="btn-ghost" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ─── Maintenance Screen ────────────────────────────────────────────────────────
